import { useTranslation } from 'react-i18next';
import { Confetti } from '@phosphor-icons/react';
import { formatDateOnly } from '@/lib/utils/custom-date/custom-date';
import { useGetHolidays } from '@/modules/settings/time-off/holidays/hooks/use-holidays';
import { orgToday } from '@/modules/time-attendance/utils/task-date';
import { HomeCard, HomeList, HomeListRow } from '../home-card/home-card';

/** How many holidays the card lists (Component Map › Upcoming holidays: the next three). */
const NEXT_HOLIDAYS = 3;

/** The organization's next holidays from Settings › Holidays, soonest first. */
export const UpcomingHolidaysCard = () => {
  const { t, i18n } = useTranslation();
  const today = orgToday();
  const { data, isLoading } = useGetHolidays({
    pageNo: 1,
    pageSize: NEXT_HOLIDAYS,
    // Holidays are date only: the day at 00:00:00 UTC.
    filter: { StartDate: { $gte: `${today}T00:00:00.000Z` } },
  });
  const holidays =
    (data as { Holidays?: { items: { ItemId: string; Name: string; StartDate: string }[] } })
      ?.Holidays?.items ?? [];

  return (
    <HomeCard title={t('HOME_UPCOMING_HOLIDAYS')}>
      <HomeList isLoading={isLoading} emptyText={t('HOME_NO_UPCOMING_HOLIDAYS')}>
        {holidays.map((holiday) => (
          <HomeListRow
            key={holiday.ItemId}
            icon={<Confetti />}
            title={holiday.Name}
            meta={`${new Date(holiday.StartDate).toLocaleDateString(i18n.language, {
              timeZone: 'UTC',
              weekday: 'long',
            })} · ${formatDateOnly(holiday.StartDate)}`}
          />
        ))}
      </HomeList>
    </HomeCard>
  );
};
